import React from 'react'
import SharedViewAppProto from "../../core/app-proto"

export default class AppSharedNotFound extends SharedViewAppProto {

    start(callback: callback) {
        this.renderNotFound()
        if (callback) callback()
    }
}